import { render, staticRenderFns } from "./TicketTemplateContainer.vue?vue&type=template&id=dbc7c778&"
import script from "./TicketTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./TicketTemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports